import { AsideMenuItemWithSub } from "../../_metronic/layout/components/aside/AsideMenuItemWithSub";
import { AsideMenuItem } from "../../_metronic/layout/components/aside/AsideMenuItem";
import { Permission, PermissionCategory } from "services/userSession/UserPermittedComponent";
import {
  faSliders,
  faUsers,
  faCalendar,
  faHandshake,
  faFilter,
  faListCheck,
  faPieChart,
  faFileInvoice,
  faArrowProgress,
  faFileLines,
  faFileImport,
} from "@fortawesome/pro-solid-svg-icons";
import { CPLModule } from "app/modules/shared/cplModules/CPLModule";
import { PermissionCategories, Permissions } from "cpl-react-common/components/Enums/Permissions";
import { CPLModules } from "cpl-react-common/components/Enums/CPLModules";
import { faSuitcase } from "@fortawesome/pro-solid-svg-icons";
import translations from "utils/translationUtility";
import { faMessageBot } from "@fortawesome/pro-regular-svg-icons";

function MenuItemSeperator() {
  return (
    <div className="menu-item">
      <div className="menu-content">
        <div className="separator"></div>
      </div>
    </div>
  );
}

export function CPLNavigationMenu() {
  return (
    <>
      <AsideMenuItem data-test-id="sidebar__dashboard-link" to="/dashboard" title={"Dashboard"} icon={faSliders} />{" "}
      <PermissionCategory
        permissionCategoryPredicate={(permissionCategory) => permissionCategory === PermissionCategories.PowerBI}
      >
        <Permission permissionPredicate={(permission) => permission === Permissions.ViewPowerBIReports}>
          <AsideMenuItem data-test-id="sidebar__power-bi-link" to="/PowerBI" title="Power BI" icon={faPieChart} />
        </Permission>
      </PermissionCategory>
      <MenuItemSeperator />
      <PermissionCategory
        permissionCategoryPredicate={(permissionCategory) => permissionCategory === PermissionCategories.Admin}
      >
        <AsideMenuItemWithSub data-test-id="sidebar__admin-toggle" to="/Admin" title="Admin" icon={faUsers}>
          <Permission permissionPredicate={(permission) => permission === Permissions.ManageCustomisableTypes}>
            <AsideMenuItem
              data-test-id="sidebar__admin-customisable-types-link"
              to="/Admin/CustomisableTypes/"
              title="Customisable Types"
              hasBullet
            />
          </Permission>
          <Permission permissionPredicate={(permission) => permission === Permissions.ManageWorkingHours}>
            <AsideMenuItem
              data-test-id="sidebar__admin-working-hours-link"
              to="/Admin/WorkingHours/"
              title="Working Hours"
              hasBullet
            />
          </Permission>
          <CPLModule module={CPLModules.ClientPortal}>
            <AsideMenuItemWithSub
              data-test-id="sidebar__admin-client-portal-toggle"
              to="/Admin/ClientPortal"
              title={`${translations.resident}s Portal`}
              hasBullet
            >
              <Permission permissionPredicate={(permission) => permission === Permissions.ViewCompanyBranding}>
                <AsideMenuItem
                  data-test-id="sidebar__admin-company-branding-link"
                  to="/Admin/CompanyBranding"
                  title="Company Branding"
                  hasBullet
                />
              </Permission>
              <Permission permissionPredicate={(permission) => permission === Permissions.EditWebNarratives}>
                <AsideMenuItem
                  data-test-id="sidebar__admin-web-narratives-link"
                  to="Admin/WebNarratives/"
                  title="Web Narratives"
                  hasBullet
                />
              </Permission>
              <Permission permissionPredicate={(permission) => permission === Permissions.ViewTermsAndConditionsEditor}>
                <AsideMenuItem
                  data-test-id="sidebar__admin-terms-and-conditions-link"
                  to="/Admin/TermsAndConditions/"
                  title="Terms And Conditions"
                  hasBullet
                />
              </Permission>
              <Permission permissionPredicate={(permission) => permission === Permissions.ViewPaymentSettings}>
                <AsideMenuItem
                  data-test-id="sidebar__admin-payment-providers-link"
                  to="/Admin/PaymentProviders/"
                  title="Payment Providers"
                  hasBullet
                />
              </Permission>
              <Permission permissionPredicate={(permission) => permission === Permissions.ViewPaymentSettings}>
                <AsideMenuItem
                  data-test-id="sidebar__admin-direct-debit-collection-days-link"
                  to="/Admin/DirectDebitCollectionDays"
                  title="Direct Debit Collection Days"
                  hasBullet
                />
              </Permission>
            </AsideMenuItemWithSub>
          </CPLModule>
          <Permission permissionPredicate={(permission) => permission === Permissions.ViewUsers}>
            <AsideMenuItemWithSub data-test-id="sidebar__admin-users-toggle" to="/Admin/Users" title="Users" hasBullet>
              <Permission permissionPredicate={(permission) => permission === Permissions.ViewUsers}>
                <AsideMenuItem
                  data-test-id="sidebar__admin-users-users-link"
                  to="/Admin/Users/Users"
                  title="Users"
                  hasBullet
                />
              </Permission>
              <Permission permissionPredicate={(permission) => permission === Permissions.ViewUserGroups}>
                <AsideMenuItem
                  data-test-id="sidebar__admin-users-user-groups-link"
                  to="/Admin/Users/UserGroups"
                  title="User Groups"
                  hasBullet
                />
              </Permission>
              <Permission permissionPredicate={(permission) => permission === Permissions.ViewPermissions}>
                <AsideMenuItem
                  data-test-id="sidebar__admin-users-permissions-link"
                  to="/Admin/Users/Permissions"
                  title="Permissions"
                  hasBullet
                />
              </Permission>
            </AsideMenuItemWithSub>
          </Permission>
          <Permission permissionPredicate={(permission) => permission === Permissions.ManageSettings}>
            <AsideMenuItem
              data-test-id="sidebar__admin-cpl-settings-link"
              to="/Admin/CPLSettings/"
              title="Settings"
              hasBullet
            />
          </Permission>
        </AsideMenuItemWithSub>
      </PermissionCategory>
      <CPLModule module={CPLModules.ClientPortal}>
        <PermissionCategory
          permissionCategoryPredicate={(permissionCategory) =>
            permissionCategory === PermissionCategories.ClientPortalUsers
          }
        >
          <AsideMenuItemWithSub
            data-test-id="sidebar__residents-toggle"
            to="/Residents"
            title="Residents"
            icon={faUsers}
          >
            <Permission permissionPredicate={(permission) => permission === Permissions.ViewClientPortalUsers}>
              <AsideMenuItem
                data-test-id="sidebar__client-portal-users-link"
                to="/ResidentsPortalUsers"
                title={`${translations.resident}s Portal Users`}
                hasBullet
              />
            </Permission>
            <CPLModule module={CPLModules.InDevelopment}>
              <Permission permissionPredicate={(permission) => permission === Permissions.ViewDirectors}>
                <AsideMenuItemWithSub
                  data-test-id="sidebar__directors-toggle"
                  to="/Directors"
                  title="Directors"
                  hasBullet
                  redirect="/Directors"
                >
                  <Permission permissionPredicate={(permission) => permission === Permissions.CreateDirectors}>
                    <AsideMenuItem
                      data-test-id="sidebar__add-director-link"
                      to="/Director"
                      title="Add Director"
                      hasBullet
                    />
                  </Permission>
                </AsideMenuItemWithSub>
              </Permission>
            </CPLModule>
          </AsideMenuItemWithSub>
        </PermissionCategory>
      </CPLModule>
      <CPLModule module={CPLModules.Scheduling}>
        <AsideMenuItemWithSub
          data-test-id="sidebar__scheduling-toggle"
          to="/Scheduling"
          title="Scheduling"
          icon={faCalendar}
        >
          <Permission permissionPredicate={(permission) => permission === Permissions.ViewAllCalendarEvents}>
            <AsideMenuItem data-test-id="sidebar__calendar-link" to="/Calendar" title="My Calendar" hasBullet />
          </Permission>
          <Permission permissionPredicate={(permission) => permission === Permissions.ViewAllMeetings}>
            <AsideMenuItemWithSub
              data-test-id="sidebar__meetings-toggle"
              to="/Meetings"
              title="Upcoming Meetings"
              icon={faHandshake}
              redirect="/Meetings"
            >
              <Permission permissionPredicate={(permission) => permission === Permissions.CreateMeetings}>
                <AsideMenuItem
                  data-test-id="sidebar__meeting-link"
                  to="/Meeting"
                  title="Schedule a meeting"
                  hasBullet
                />
              </Permission>
            </AsideMenuItemWithSub>
          </Permission>
          <AsideMenuItemWithSub
            data-test-id="sidebar__user-tasks-toggle"
            to="/UserTasks"
            title="My Tasks"
            icon={faListCheck}
            redirect="/UserTasks"
          >
            <AsideMenuItem data-test-id="sidebar__user-task-link" to="/UserTask" title="Create a task" hasBullet />
          </AsideMenuItemWithSub>
        </AsideMenuItemWithSub>
      </CPLModule>
      <CPLModule module={CPLModules.ROUK}>
        <PermissionCategory
          permissionCategoryPredicate={(permissionCategory) =>
            permissionCategory === PermissionCategories.GlobalProcesses
          }
        >
          <AsideMenuItemWithSub
            data-test-id="sidebar__global-processes-toggle"
            to="/GlobalProcesses"
            title="Global Processes"
            icon={faArrowProgress}
          >
            <PermissionCategory
              permissionCategoryPredicate={(permissionCategory) =>
                permissionCategory === PermissionCategories.ServiceChargeInvoicing
              }
            >
              <AsideMenuItemWithSub
                data-test-id="sidebar__service-charge-invoicing-wizard-toggle"
                to="/ServiceChargeInvoicing/Wizard"
                title="Service Charge Invoices"
                icon={faFileInvoice}
                redirect="/ServiceChargeInvoicing/Wizard"
              >
                <Permission
                  permissionPredicate={(permission) => permission === Permissions.GenerateServiceChargeInvoice}
                >
                  <AsideMenuItem
                    data-test-id="sidebar__service-charge-invoicing-wizard-link"
                    to="/ServiceChargeInvoicing/Wizard"
                    title="Generate Service Charge Invoices"
                    hasBullet
                  />
                </Permission>
                <Permission
                  permissionPredicate={(permission) => permission === Permissions.ViewServiceChargeInvoiceSummaries}
                >
                  <AsideMenuItem
                    data-test-id="sidebar__service-charge-invoicing-link"
                    to="/ServiceChargeInvoicing"
                    title="Service Charge Invoice Summaries"
                    hasBullet
                  />
                </Permission>
              </AsideMenuItemWithSub>
            </PermissionCategory>
            <PermissionCategory
              permissionCategoryPredicate={(permissionCategory) =>
                permissionCategory === PermissionCategories.AnticipatedExpenditure
              }
            >
              <Permission
                permissionPredicate={(permission) => permission === Permissions.GenerateAnticipatedExpenditureReport}
              >
                <AsideMenuItemWithSub
                  data-test-id="sidebar__anticipated-expenditure-toggle"
                  to="/AnticipatedExpenditure"
                  title="Anticipated Expenditure"
                  icon={faFileLines}
                  redirect="/AnticipatedExpenditure"
                >
                  <AsideMenuItem
                    data-test-id="sidebar__anticipated-expenditure-link"
                    to="/AnticipatedExpenditure"
                    title="Generate Anticipated Expenditure Report"
                    hasBullet
                  />
                </AsideMenuItemWithSub>
              </Permission>
            </PermissionCategory>
          </AsideMenuItemWithSub>
        </PermissionCategory>
      </CPLModule>
      <CPLModule module={CPLModules.Cases}>
        <PermissionCategory
          permissionCategoryPredicate={(permissionCategory) => permissionCategory === PermissionCategories.Cases}
        >
          <Permission permissionPredicate={(permission) => permission === Permissions.ViewAllCases}>
            <AsideMenuItemWithSub
              data-test-id="sidebar__cases-toggle"
              to="/Cases"
              title="Cases"
              icon={faFilter}
              redirect="/Cases"
            >
              <Permission permissionPredicate={(permission) => permission === Permissions.CreateCases}>
                <AsideMenuItem data-test-id="sidebar__case-link" to="/Case" title="Open a case" hasBullet />
              </Permission>
            </AsideMenuItemWithSub>
          </Permission>
        </PermissionCategory>
      </CPLModule>
      <CPLModule module={CPLModules.Jobs}>
        <AsideMenuItem data-test-id="sidebar__jobs-link" to="/Jobs" title="Jobs" icon={faSuitcase} />
      </CPLModule>
      <CPLModule module={CPLModules.Estimates}>
        <AsideMenuItem data-test-id="sidebar__estimates-link" to="/Estimates" title="Estimates" icon={faFilter} />
      </CPLModule>
      <CPLModule module={CPLModules.AIAssistant}>
        <AsideMenuItem data-test-id="sidebar__assistimo-link" to="/assistimo" title="Assistimo" icon={faMessageBot} />
      </CPLModule>
      <CPLModule module={CPLModules.DataImport}>
        <PermissionCategory
          permissionCategoryPredicate={(permissionCategory) => permissionCategory === PermissionCategories.DataImport}
        >
          <Permission permissionPredicate={(permission) => permission === Permissions.AccessSelfServiceDataImport}>
            <AsideMenuItem
              data-test-id="sidebar__data-import-link"
              to="/DataImport"
              title="Data Import"
              icon={faFileImport}
            />
          </Permission>
        </PermissionCategory>
      </CPLModule>
    </>
  );
}
